import React from 'react';
import { useTranslate } from 'react-admin';
import { Tooltip } from '@mui/material';
import type { StatusRole } from '@/lightTheme';
import { StatusDot } from '@/components/shell';
import type { HealthStatus } from '../types';

const TONE: Record<HealthStatus, StatusRole> = { healthy: 'ok', degraded: 'attention', down: 'problem' };

interface HealthDotProps {
  status: HealthStatus;
  /** Overrides the status word (a server reports its own, e.g. "Online"). */
  label?: string;
  /** The probe's error, reachable on hover and focus. */
  tooltip?: string;
}

/** A service's health as a dot and a word — every row has one, so it is not a chip (hybrid-3c §8). */
export const HealthDot: React.FC<HealthDotProps> = ({ status, label, tooltip }) => {
  const t = useTranslate();
  const dot = <StatusDot tone={TONE[status]} label={label ?? t(`screens.techSupport.health.${status}`)} />;
  if (!tooltip) return dot;
  return (
    <Tooltip title={tooltip}>
      <span tabIndex={0}>{dot}</span>
    </Tooltip>
  );
};
